module.exports = __webpack_public_path__ + "static/Demo-16af6a8e5d4f738c6d172911e944d8d5.png";